import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from './generic/box/box';

// Shown only when a request is slow enough to need it, so it replaces nothing on
// a fast navigation. It arrives after the page has rendered, so it announces
// itself to a screen reader rather than waiting to be read.
const PageLoading = (): React.ReactElement => {
  const { t } = useTranslation();

  return (
    <Box as="p" role="status" aria-live="polite" style={{ opacity: 0.7 }} className="kb-page-loading">
      {t('loading')}
    </Box>
  );
};

export default PageLoading;
